var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChats = function SvgIconChats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4.75v9.656l2.084-1.684a1 1 0 0 1 .629-.222H15.5V4.75zm13.5 2.5V4.5a1.75 1.75 0 0 0-1.75-1.75h-12A1.75 1.75 0 0 0 2 4.5v12a1 1 0 0 0 1.629.778l2.871-2.32v2.292A1.75 1.75 0 0 0 8.25 19h8.684l3.438 2.778A1 1 0 0 0 22 21V9a1.75 1.75 0 0 0-1.75-1.75zm0 2v3.5a1.75 1.75 0 0 1-1.75 1.75H8.5V17h8.788a1 1 0 0 1 .628.222L20 18.906V9.25z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChats;